import _ from "lodash";
import {
  Component,
} from "react";
import {
  Spinner,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import antragApi from "Apis/antrag-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import SHKFormTab, {
  setupAntragPanels,
} from "App/shk-form-tab";
import {
  subpanels as subpanels_lbvperson,
} from "App/person-lbvperson-tab";
import {
  ASTMODUSKEY,
  getModusFromAntrag,
  ROLLEN,
} from "App/constants";

const panels = _.cloneDeep([...subpanels_lbvperson]);
const mapping = [{ endpoint: "/api/shkperson/lbvperson", prop: "antrag_lbvperson", pfrom: "lbp_", pto: "alv_" }];
setupAntragPanels(panels, mapping);

const injects = _.flatMap(panels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

@store(...injects, "user")
@antragApi.current
export default class AntragLBVPersonTab extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const { currentAntrag, user } = this.props;
    if (!currentAntrag) {
      return <Spinner />;
    }
    // Für Sachb alle Hilfstexte herausfiltern
    if (user.ro_id != ROLLEN.ROLLE_ANTRAGSTELLER) {
      _.map(panels, p => p.schema.table = p.schema.table.filter(f => f.type != "plaintext"));
    }

    let usepanels = panels;
    if (getModusFromAntrag(currentAntrag) == ASTMODUSKEY.Hilfskraft) {
      // Bei Hilfskräften Kinder-Panel weglassen
      usepanels = panels.filter(x => x.key != "kinder");
    }

    return <SHKFormTab
      readonly
      args={{ a_id: currentAntrag.a_id }}
      subpanels={usepanels}
      injects={selectInjects(this.props)} />;
  }
}
